import React, { Component } from "react";
import { DatePicker } from "antd";
import locale from "antd/es/date-picker/locale/es_ES";
import moment from "moment";
import "moment/locale/es";

class DatePickerItem extends Component {
    pickerRef = React.createRef();

    state = {
        innerValue: null,
    };

    focus(value) {
        return this.pickerRef.current?.focus(value);
    }

    parseFechaFlexible = (raw) => {
        if (!raw) return null;

        const trimmed = String(raw).trim();

        const digits = trimmed.replace(/\D/g, "");
        if (digits.length === 8) {
            const dd = digits.slice(0, 2);
            const mm = digits.slice(2, 4);
            const yyyy = digits.slice(4, 8);
            const asSlash = `${dd}/${mm}/${yyyy}`;
            const d = moment(asSlash, "DD/MM/YYYY", true);
            return d.isValid() ? d : null;
        }

        const formats = [
            "DD/MM/YYYY",
            "D/M/YYYY",
            "DD-MM-YYYY",
            "D-M-YYYY",
            "DD.MM.YYYY",
            "D.M.YYYY",
            "YYYY-MM-DD",
        ];

        const d = moment(trimmed, formats, true);
        return d.isValid() ? d : null;
    };

    setDate = (d) => {
        const ahora = moment();

        const conHoraActual = d
            .clone()
            .hour(ahora.hour())
            .minute(ahora.minute())
            .second(ahora.second());

        const formatted = conHoraActual.format(
            this.props.dateFormat || "DD/MM/YYYY HH:mm:ss"
        );

        if (this.props.onChange) {
            this.props.onChange(conHoraActual, formatted);
        }

        if (this.props.value === undefined) {
            this.setState({ innerValue: conHoraActual });
        }
    };

    handleKeyDown = (e) => {
        const safeKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "Tab",
            "Home",
            "End",
        ];
        if (safeKeys.includes(e.key)) return;

        const allowedChar = /[0-9/.-]/.test(e.key);
        if (!allowedChar) {
            e.preventDefault();
            return;
        }

        const input = e.target;
        const current = input.value || "";
        const start = input.selectionStart ?? current.length;
        const end = input.selectionEnd ?? current.length;

        const next = current.slice(0, start) + e.key + current.slice(end);

        const d = this.parseFechaFlexible(next);

        if (d) {
            e.preventDefault();
            this.setDate(d);
        }
    };

    render() {
        const style = {
            color: this.props.disabled ? "black" : null,
            backgroundColor: this.props.disabled ? "white" : null,
            borderBottom: this.props.sinBorde ? null : "1px solid #DADADA",
            borderRadius: 0,
            width: this.props.width ? this.props.width : undefined,
            ...this.props.style,
        };

        const dateFormat = this.props.dateFormat || "DD/MM/YYYY";
        const value = this.props.value ?? this.state.innerValue;

        return (
            <DatePicker
                className={`custom-disabled-select ${this.props.disabled ? "custom-disabled" : ""}`}
                ref={this.pickerRef}
                locale={locale}
                style={style}
                format={dateFormat}
                bordered={false}
                {...this.props}
                value={value}
                onKeyDown={this.handleKeyDown}
            />
        );
    }
}

export default DatePickerItem;